<div class="alert-container">

  <div class="alert-header">
    {{ data.header || data.title }}
  </div>

  <div class="alert-body">
    {{ data.description || data.body }}
  </div>

  <div class="alert-actions">
    <button *ngIf="noLabel" type="button" class="btn btn-secondary" (click)="cancelDialog()">
      {{ noLabel }}
    </button>

    <button type="button" class="btn btn-danger" (click)="yesDialog()">
      {{ yesLabel }}
    </button>
  </div>

</div>